<template>
    <div class="side-box">
        <v-layout justify-space-between align-center class="side-box-header">
            <div class="side-box-title">{{$t('markAsDone')|capitalize}}</div>
            <v-icon @click="toggleMarkAsDone">mdi-close</v-icon>
        </v-layout>
        <div class="side-box-content">
            <v-card flat>
                <v-card-text>
                  <v-form ref="form">
                    <v-layout wrap>
                        <v-flex xs12 style="padding: 9px 0px">
                            <span class="label">{{$t('requestDescription')|capitalize}}</span>
                        </v-flex>
                        <v-flex xs12>
                            <v-textarea
                                    ref="description"
                                    solo
                                    background-color="#F7F7FC"
                                    auto-grow
                                    flat
                                    rows="3"
                                    v-model="description"
                                    :rules="formRules.required"
                            ></v-textarea>
                        </v-flex>
                        <v-flex xs12 class="py-2">
                          <div class="btn-template" @click="openDialogMADTemplate">
                            <img src="/icon/template.svg">
                            <span style="font-size: 14px; color: #0052CC;" class="px-2">
                            {{ $t('templateDesc') | capitalize }}
                          </span>
                          </div>
                        </v-flex>
                        <v-flex xs12 style="padding: 9px 0px">
                            <span class="label">{{$t('sessionNotes')|capitalize}}</span>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    ref="notes"
                                    solo
                                    background-color="#F7F7FC"
                                    flat
                                    v-model="notes"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 style="padding: 9px 0px">
                            <span class="label">{{$t('topic')|capitalize}}</span>
                        </v-flex>
                        <v-flex xs12 v-if="!options || options.length < 1">
                            <v-text-field
                                    class="filter-select"
                                    ref="topic"
                                    solo
                                    background-color="#F7F7FC"
                                    flat
                                    v-model="topic"
                                    :rules="isRequiredTopicMad ? formRules.required : []"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 v-else style="padding: 9px 0px">
                            <treeselect
                                    :required="true"
                                    :options="options"
                                    v-model="topicVal"
                                    :normalizer="normalizer"
                                    value-consists-of="ALL_WITH_INDETERMINATE"
                                    @select="updateTopic"
                            >
                            </treeselect>
                          <div class="mx-3 mt-2 error--text v-messages" v-if="!topicVal && isRequiredTopicMad">
                            {{$t('formRules.fieldRequired')}}
                          </div>
                        </v-flex>
                        <v-flex xs12>
                            <v-checkbox color="primary" v-model="chatView.customer.need_re_support" :label="$t('markAsImportant')|capitalize"></v-checkbox>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox :disabled="isDisabledCSATCheckBox" color="primary" v-model="is_create_rating" :label="$t('sendRating')|capitalize"></v-checkbox>
                        </v-flex>
                        <v-flex xs12 class="create_new_request" v-show="allow_create_new_request">
                            <v-checkbox
                                v-model="is_create_new_request_human_support"
                                color="primary"
                                :label="$t('createNewRequestHumanSupport') | capitalize"
                            ></v-checkbox>
                            <div class="mb-1" style="color:#888A9A" v-show="is_create_new_request_human_support">
                                {{$t('requestSupportSkill') | capitalize}}
                            </div>
                            <v-select
                                :items="categories_choices"
                                v-model="selected_category"
                                item-text="name"
                                return-object
                                solo
                                class="fti-select"
                                v-show="is_create_new_request_human_support"
                                small
                            ></v-select>
                            <div class="mb-1" style="color:#888A9A" v-show="is_create_new_request_human_support">
                                {{$t('requestContent') | capitalize}}
                            </div>
                            <v-textarea
                                solo
                                background-color="#F7F7FC"
                                auto-grow
                                flat
                                rows="3"
                                v-model="request_comment"
                                hide-details
                                v-show="is_create_new_request_human_support"
                            ></v-textarea>
                            <v-checkbox
                                v-model="is_disable_bot"
                                color="primary"
                                :label="$t('disableBot') | capitalizeAll"
                                v-show="is_create_new_request_human_support"
                            ></v-checkbox>
                        </v-flex>
                    </v-layout>
                  </v-form>
                </v-card-text>
                <v-card-actions style="padding-bottom: 40px">
                    <v-spacer></v-spacer>
                    <v-btn :disabled="loading" :loading="loading" color="#F7722F" @click="markAsDoneBtn">
                        {{$t('markAsDone')|capitalize}}
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </div>
    </div>
</template>
<script>
import {mapActions, mapMutations, mapState} from "vuex";
import BotService from "@/services/bot.service";
import StaffService from "@/services/staff.service";
import FormMixin from '@/mixins/FormMixin'
import _ from "lodash"
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import CustomerService from "@/services/customer.service";
import {sync} from "vuex-pathify";

export default {
        name: "MarkAsDone",
        mixins: [FormMixin],
        computed: {
            ...mapState(['user', 'token', 'bot', 'chatView']),
            ...mapState('config', ['botConfig']),
            cfg: sync('rating/ratingCfg'),
            form() {
                return {
                    description: this.description,
                    // notes: this.notes,
                    // topic: this.topic,

                }
            },
            isRequiredTopicMad() {
              return this.botConfig["requiredTopicMad"] === "1"
            },
            isDisabledCSATCheckBox() {
              return this.cfg.is_auto_send || this.is_create_new_request_human_support
            }
        },
        components: { Treeselect },
        data() {
            return {
                description: '',
                notes: '',
                topic: null,
                topicVal: null,
                loading: false,
                items: [],
                options: [],
                customer_attributes: {},
                optionsFlat: [],
                me: (StaffService.getMe() || {}),
                categories_choices: [],
                allow_create_new_request: false,
                is_create_new_request_human_support: false,
                is_create_rating: false,
                request_comment: "",
                is_disable_bot: true,
                selected_category: null,
            }
        },
        mounted() {
            this.getCustomInfo();
            this.loadAttributesOfCustomer();
            this.checkIsAllowCreateNewRequest();
            this.fetchRatingCfg();
            this.$EventBus.$on(this.$EventBusType.ON_USE_MAD_TEMPLATE, this.onUseMADTemplate)
        },
        methods: {
            ...mapMutations('sideBox', ['toggleMarkAsDone']),
            ...mapActions('dialog', ['openDialogMADTemplate', 'closeDialogMADTemplate']),
            ...mapActions('rating', ['fetchRatingCfg']),
            onUseMADTemplate(data) {
              this.description = data.content
              this.closeDialogMADTemplate()
            },
            updateTopic(node, instanceId)
            {
                let topicArr = [];
                this.customTopicValue(node, topicArr);
                let topic = {};
                for (let i = 0; i< topicArr.length; i++) {
                    Object.assign(topic, {[`level_${i + 1}`]: topicArr[i]})
                }
                this.topic = topic
            },
            flatOptions(options, result) {
                for (let option of options) {
                    let cdata = _.pick(option, 'id', 'pid', 'name');
                    result.push(cdata)
                    if (option.children) {
                        this.flatOptions(option.children, result)
                    }
                }
            },
            customTopicValue(node, result) {
                result.unshift(node.name)
                if (node && node.pid!==0) {
                    let parent = _.find(this.optionsFlat, o=> o.id === node.pid)
                    this.customTopicValue(parent, result)
                }
            },
            markAsDoneBtn() {
                if ((this.options && this.options.length >= 1) && !this.topicVal) {
                  this.topic = "";
                }
                if (!this.$refs.form.validate() || (this.isRequiredTopicMad && !this.topic)) {
                  return;
                }
              let is_create_new_request_human_support = false, is_disable_bot = false, request_comment = "",
                  request_support_categories = [];
              if (this.allow_create_new_request === true && this.is_create_new_request_human_support === true) {
                if (!this.selected_category) {
                  this.$AppService.toastError('Invalid request support skill');
                  return;
                } else {
                  is_create_new_request_human_support = true;
                  is_disable_bot = this.is_disable_bot;
                  request_comment = this.request_comment;
                  request_support_categories = [this.selected_category];
                }
              }

              this.loading = true;
              let botCode = this.$route.params.bot_code;
              let senderId = this.$route.params.senderId;
              BotService.markSupportDone(senderId, botCode,
                  is_create_new_request_human_support, is_disable_bot,
                  request_comment, request_support_categories,
                  this.chatView.customer.need_re_support,
                  this.description, this.notes,
                  this.topic,
                  this.customer_attributes,
                  this.is_create_rating
              )
                  .then(
                      () => {
                        this.$AppService.toastSuccess('Marked as done');
                        this.loading = false;
                        this.$refs.form.reset();
                        this.toggleMarkAsDone();
                      },
                      this.$AppService.handleRequestError('Can not mark as done'));
            },
            getCustomInfo() {
                let botCode = this.$route.params.bot_code;
                BotService.getCustomInfo(botCode)
                    .then((res)=>{
                        this.options = [];
                        this.options =  res.data.data.children;
                        this.flatOptions(this.options, this.optionsFlat);
                    })
                    .catch(()=> {
                        this.$AppService.handleRequestError("Cannot get custom info")
                    });
            },
            normalizer(node) {
                return {
                    id: node.name,
                    label: node.name
                }
            },
            async loadAttributesOfCustomer() {
                let botCode = this.$route.params.bot_code;
                let customerId = this.$route.params.senderId;
                if (!botCode || !customerId) {
                    return
                }
                CustomerService.getCustomerAttributes(botCode, customerId).then(
                    result_atts => {
                        this.customer_attributes = result_atts.data;
                    },
                );
            },
            checkIsAllowCreateNewRequest() {
                let autoAssignConfigMap = this.$store.state.autoAssignConfigMap;
                let all_categories = this.$store.state.requestSupportCategories;
                let current_supporter_category_ids;
                if (this.me && this.me.id) {
                    current_supporter_category_ids = autoAssignConfigMap[this.me.id] ? (autoAssignConfigMap[this.me.id].request_support_categories || []) : []
                } else {
                    current_supporter_category_ids = []
                }
                this.categories_choices = [];
                for (let category of all_categories) {
                    if (!current_supporter_category_ids.includes(category.id))
                        this.categories_choices.push({
                            id: category.id,
                            name: category.name,
                        });
                }
                if (this.categories_choices.length > 0) {
                    this.allow_create_new_request = true;
                    this.selected_category = this.categories_choices[0]
                } else {
                    this.allow_create_new_request = false;
                    this.selected_category = null;
                }
                this.is_create_new_request_human_support = false;
                this.is_disable_bot = true;
                this.request_comment = "";
            }
        },
        watch: {
          cfg() {
            this.is_create_rating = this.cfg.is_auto_send
          },
          is_create_new_request_human_support() {
            if (this.is_create_new_request_human_support) {
              this.is_create_rating = false;
            } else {
              this.is_create_rating = this.cfg.is_auto_send;
            }
          }
        }
    }

</script>
<style scoped lang="scss" src="../style/side-box.scss"></style>
<style scoped lang="scss" src="../style/staff.scss"></style>
<style scoped lang="scss" src="../style/mark-as-done.scss"></style>
